/**
 * Waits for an element to be found
 * @param getElement - A function that returns the element to wait for
 * @param maxAttempts - The maximum number of attempts to make
 * @param delay - The delay between attempts
 * @returns A promise that resolves with the element
 */
export const waitElement = (getElement: () => HTMLElement | null, maxAttempts = 100, delay = 100) => {
  return new Promise<HTMLElement>((resolve, reject) => {
    let attempts = 0
    const interval: NodeJS.Timeout = setInterval(() => {
      attempts++
      const element = getElement()
      if (element) {
        clearInterval(interval)
        resolve(element)
      } else if (attempts > maxAttempts) {
        clearInterval(interval)
        reject('Element not found')
      }
    }, delay)
  })
}
